module.exports = __webpack_public_path__ + "img/BOARD.2e83609e.svg";